import {
    Container,
    Typography,
    Box,
    Stack,
} from "@mui/material";
import React from 'react';
import { useTranslation, Translation } from "react-i18next";
import { getLang } from "../../helper/LangHelper";
import { useFormik } from "formik";
import { Button, TextField } from "@mui/material";
import { toast } from "react-toastify";
import Resizer from "react-image-file-resizer";

const resizeFile = ({
    file,
    maxWidth = 1080,
    maxHeight = 1080,
    extension = "webp", // "WEBP" | "JPEG" | "PNG"
    outputType = "file", // "file" | "base64" | "blob"
}) =>
    new Promise((resolve) => {
        Resizer.imageFileResizer(
            file,
            maxWidth,
            maxHeight,
            extension,
            100,
            0,
            (uri) => {
                resolve(uri);
            },
            outputType
        );
    });

    // create an async function for resizeFile
const resizeFileAsync = async ({
    file,
    maxWidth = 1080,
    maxHeight = 1080,       
    extension = "webp", // "WEBP" | "JPEG" | "PNG"
    outputType = "file", // "file" | "base64" | "blob
}) => {
    return new Promise((resolve) => {
        Resizer.imageFileResizer(
            file,
            maxWidth,
            maxHeight,
            extension,      
            100,
            0,
            (uri) => {
                resolve(uri);
            },
            outputType
        );
    });
}

const getUploadImageData = async (imageData) => {
    if (imageData === undefined || imageData === null) return "";
    if (typeof imageData === "string") {
        return imageData;
    }

    if (imageData === "" || imageData === null) {
        return imageData
    }

    if (typeof imageData === "object") {
        return convertBase64(imageData);
    }
    // convertBase64
    return "";
}

const infoFileSize = (file) => {
    if (!file) {
        return "No file selected";
    }
    const fileSize = (file.size / 1024).toFixed(2); //
    if (fileSize < 1024) {
        return `File selected: ${file.name} (${fileSize} KB)`;
    } else {
        const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);
        return `File selected: ${file.name} (${fileSizeMB} MB)`;
    }
}



export default function TestSimple() {
    const { t } = useTranslation();

    let lang = getLang();

    let unitName = "次";

    const onChangeStandard = (values) => {
        console.debug("onChangeStandard called: ", values);
    };

    // const formik = useFormik({
    //     initialValues: {    
    //         // Add file upload field
    //         file: null,
    //     },
    //     onSubmit: (values) => {
    //         console.debug("onSubmit called: ", values);
    //         onChangeStandard(values);
    //     }
    // });

    const formik = useFormik({
        initialValues: {
            file: null,
        },
        onSubmit: async (values) => {
            console.debug("onSubmit called: ", values);
            const file = values.file;
            if (!file) {
                toast.error("Please select a file to upload.");
                return;
            }
            // Show the size of the file
            // const fileSize = (file.size / 1024).toFixed(2); // Convert to KB
            // toast.info(`File selected: ${file.name} (${fileSize} KB)`);
            toast.info("Original size: " + infoFileSize(file));


            let resizedFile = await resizeFileAsync({
                file: file,
                maxWidth: 1080,     
                maxHeight: 1080,
                extension: "jpeg", // "WEBP" | "JPEG" | "PNG"
                outputType: "file", // "file" | "base64" | "blob
            });

            console.debug("Resized file: ", resizedFile);
            toast.info("Resized size: " + infoFileSize(resizedFile));

            // // Resize the file
            // let resizedFile = resizeFile({
            //     file: file,
            //     maxWidth: 1080,
            //     maxHeight: 1080,            
            //     extension: "webp", // "WEBP" | "JPEG" | "PNG"
            //     outputType: "file", // "file" | "base64" | "blob     
            // }).then((resizedFile) => {
            //     console.debug("Resized file: ", resizedFile);
            //     toast.info("Resized size: " + infoFileSize(resizedFile));
            //     // You can now upload the resized file to your server
            //     // For example, you can use FormData to send the file to your server
            //     const formData = new FormData();
            //     formData.append("file", resizedFile, resizedFile.name); 
            //     // Here you can make an API call to upload the file
            //     // For example:
            //     // axios.post('/api/upload', formData, {        


            // 
            // onChangeStandard(values);
        }
    });

    const handleFileChange = (event) => {
        formik.setFieldValue("file", event.currentTarget.files[0]);
    };



    return (
        <Container maxWidth="lg">
            <Stack direction="column">
                <Box>
                    <Typography variant="h3">Upload Form </Typography>
                </Box>

                <Box>
                    <form onSubmit={formik.handleSubmit}>
                        <Stack spacing={2}>
                            <TextField
                                type="file"
                                name="file"
                                onChange={handleFileChange}
                                fullWidth
                            />
                            <Button type="submit" variant="contained">
                                Submit
                            </Button>
                        </Stack>
                    </form>
                </Box>

                <Box>
                    <p>Current Lang: {lang}</p>
                    <p>translateText: {t("testing.msg")}</p>
                </Box>
            </Stack>
        </Container>
    )
}
